import cropDraftService from "./cropDraftService";

const applicationDraftService = [
    ...cropDraftService
]

export default applicationDraftService;